import React from "react"
import FontAwesome from "react-fontawesome"
import PropTypes from "prop-types"
import "./WelcomeBanner.scss"
import welcomeImage from "./welcome-image.png"

class WelcomeBanner extends React.PureComponent {
  render() {
    return (
      <div className="WelcomeBanner">
        <button
          title="close"
          className="close"
          onClick={() => {
            this.props.onClose && this.props.onClose()
          }}
        >
          <FontAwesome name="times" />
        </button>
        <img src={welcomeImage} alt={"Welcome"} className={"welcome-image"} />
        <div className="description">
          <h2>Welcome to Asset Utilization</h2>
          <p>
            Asset Utilization is designed to help you make better asset
            distribution, purchasing and rental decisions. By analyzing the
            historical movement of your tagged assets in and out of patient
            rooms over time, Asset Utilization provides key insights such as:
          </p>
          <ul>
            <li>Number of assets available during peak usage</li>
            <li>Average asset utilization</li>
            <li>Utilization across units</li>
          </ul>
          {/* Uncomment the following when we have a support page */}
          {/* <p>Visit our support center to learn more!</p>
          <a
            className="btn-primary"
            href="https://support.swipesense.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn More
          </a> */}
        </div>
      </div>
    )
  }
}

WelcomeBanner.propTypes = {
  onClose: PropTypes.func,
}

export default WelcomeBanner
